var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54175 6.02869C1.54175 9.46539 4.54825 12.3074 5.87901 13.397C6.06946 13.553 6.16583 13.6319 6.30792 13.6719C6.41856 13.703 6.5814 13.703 6.69204 13.6719C6.83439 13.6318 6.93009 13.5537 7.12126 13.3971C8.45201 12.3075 11.4584 9.46571 11.4584 6.029C11.4584 4.72842 10.936 3.48095 10.0061 2.5613C9.07626 1.64165 7.81517 1.125 6.50014 1.125C5.18511 1.125 3.92388 1.64173 2.99401 2.56138C2.06414 3.48103 1.54175 4.72811 1.54175 6.02869Z",
    stroke: "#003057",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08341 5.375C5.08341 6.1574 5.71768 6.79167 6.50008 6.79167C7.28248 6.79167 7.91675 6.1574 7.91675 5.375C7.91675 4.5926 7.28248 3.95833 6.50008 3.95833C5.71768 3.95833 5.08341 4.5926 5.08341 5.375Z",
    stroke: "#003057",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoction);
export default __webpack_public_path__ + "static/media/loction.7ab8e06228b46b32f369fd3b425b410d.svg";
export { ForwardRef as ReactComponent };